// extracted by mini-css-extract-plugin
module.exports = {"list":"list-cd27b7d2","list__item":"list__item-3d511775","list__item_special_offer":"list__item_special_offer-e17ad0a7"};